/** Órganos de gobierno cooperativo gestionados en BD. */
export const ENTES_ADMIN_ORGANOS = [
  {
    id: 'consejo_administracion',
    label: 'Consejo de Administración',
    description:
      'Órgano de dirección y administración elegido por la Asamblea General. Define políticas institucionales y supervisa la gestión de la cooperativa.',
  },
  {
    id: 'junta_vigilancia',
    label: 'Junta de Vigilancia',
    description:
      'Vela por el cumplimiento de estatutos, reglamentos y decisiones de la Asamblea. Ejerce control fiscal y de gestión sobre los órganos de administración.',
  },
];

export const ENTES_ADMIN_ORGANO_IDS = ENTES_ADMIN_ORGANOS.map((o) => o.id);

export function getEnteAdminOrganoLabel(id) {
  return ENTES_ADMIN_ORGANOS.find((o) => o.id === id)?.label ?? id;
}

export function isValidEnteAdminOrgano(id) {
  return ENTES_ADMIN_ORGANO_IDS.includes(id);
}
